export function deleteFiles(fileIris, $axios) {
    return Promise.all(fileIris.map((iri) => {
        return $axios.delete(iri);
    })).then(() => {
        // No op
    });
}
